import localforage from 'localforage';

localforage.config({
  driver: [localforage.LOCALSTORAGE, localforage.INDEXEDDB],
  name: 'recrutai',
  storeName: 'user_storage'
});

export default localforage;
